<template>
  <div style="flex: 1 1 0;">
    <ImageUploader @click="$refs.iminput.onObserve()" @change="onImageSelected">
      <v-file-input 
        @change="onImageSelected"
        prepend-icon="mdi-upload"
        accept="image/png, image/jpeg, image/jpg, image/webp"
        :label="'Выберите изображение размером не менее'+` ${canvas.minWidth}x${canvas.minHeight}px`"
        ref="iminput"
      />
    </ImageUploader>
    <v-dialog :value="image.src" scrollable @click:outside="clear">
      <v-card>
        <v-card-title>Редактирование изображения</v-card-title>
        <v-card-text class="grab-container">
          <Cropper 
            style="height: 80vh"
            :src="image.src"
            @change="onChange"
            :size-restrictions-algorithm="pixelsRestriction"
            :stencil-props="{
              aspectRatio: aspectRatio,
              movable: false,
              scalable: false,
              previewClass: circled ? 'circled' : ''
            }"
            :stencil-size="stencil"
            image-restriction="stencil"
          />  
        </v-card-text>
        <v-card-actions>
          <v-btn :disabled="!image" @click="clear" text>Очистить</v-btn>
          <v-spacer></v-spacer>
          <v-btn :disabled="!image" @click="onSave" color="primary" text>Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
import 'vue-advanced-cropper/dist/theme.compact.css';
import ImageUploader from './ImageUploader.vue'

export default {
  data() {
		return {
			coordinates: {
				width: 1080,
				height: 1080,
				left: 0,
				top: 0,
			},
			image: {},
      alert: false
		}
	},
	components: {
		Cropper,
    ImageUploader
	},
	props: {
    aspectRatio: {
      type: Number,
      default: 16/9
    },
    aspectWidth: {
      type: Number,
      default: 1080
    },
    circled: {
      type: Boolean,
      default: false
    },
    stencil_width: {
      type: Number,
      default: 360
    }
  },
	computed: {
		
    canvas(){
      return {
        minWidth: this.aspectWidth,
        minHeight: Math.ceil(this.aspectWidth / this.aspectRatio)
      }
    },
    stencil(){
      return {
        width: this.stencil_width,
        height: Math.ceil(this.stencil_width / this.aspectRatio)
      }
    }
	},
	methods: {
    async onSave(){
      this.$emit('onResult', await this.results())
    },
    async results(){
      let r = await fetch(this.image.src)
      let image = await r.blob()
      let crop = [
        this.coordinates.left,
        this.coordinates.top,
        this.coordinates.left + this.coordinates.width,
        this.coordinates.top + this.coordinates.height
      ]
      console.log({image, crop})
      return {image, crop}
    },

    clear(){
      if (this.image.src) {
        URL.revokeObjectURL(this.image.src)
      }

      this.image = {}
    },
    onImageSelected(e){
      if (e) {
        this.loadImage(e)
      } else {
        this.image = {}
      }
    },
    getMimeType(file, fallback = null) {
      const byteArray = (new Uint8Array(file)).subarray(0, 4);
        let header = '';
        for (let i = 0; i < byteArray.length; i++) {
          header += byteArray[i].toString(16);
        }
      switch (header) {
            case "89504e47":
                return "image/png";
            case "47494638":
                return "image/gif";
            case "ffd8ffe0":
            case "ffd8ffe1":
            case "ffd8ffe2":
            case "ffd8ffe3":
            case "ffd8ffe8":
                return "image/jpeg";
            default:
                return fallback;
        }
    },
    getMeta: (url) => new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = (err) => reject(err);
      img.src = url;
    }),
    async loadImage(file) {
      const blob = URL.createObjectURL(file);    
      // Create a new FileReader to read this image binary data
      const reader = new FileReader();

      this.image = await new Promise(r => {
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.image" refers to the image of Vue component
          r({
            // Set the image source (it will look like blob:http://example.com/2c5270a5-18b5-406e-a4fb-07427f5e7b94)
            src: blob,
            // Determine the image type to preserve it during the extracting the image from canvas:
            type: this.getMimeType(e.target.result, file.type),
          })
        };

        // Start the reader job - read file as a data url (base64 format)
        reader.readAsArrayBuffer(file);
      })
      // Define a callback function to run, when FileReader finishes its job
      
      let img = await this.getMeta(this.image.src)

      if ((img.naturalWidth < this.canvas.minWidth) || (img.naturalHeight < this.canvas.minHeight)) {
        this.clear()
        this.$store.dispatch('throwTimeoutMessage', {
          text: `'Выберите изображение размером не менее' ${this.canvas.minWidth}x${this.canvas.minHeight}px`,
          message_class: 'error'
        })
        this.clear()
        return
      }
		},
    pixelsRestriction() {
			return this.canvas
		},
    onChange({ coordinates }) {
      if (coordinates.width == 0 && coordinates.height == 0 && coordinates.top == 0 && coordinates.left == 0) {
        return
      }

      
			this.coordinates = coordinates;
			// You able to do different manipulations at a canvas
			// but there we just get a cropped image, that can be used 
			// as src for <img/> to preview result
		},
	},
  destroyed(){
    this.clear()
  },
  mounted(){
    console.log(this.$refs.iminput)
  }
};
</script>

<style>
.circled {
  border-radius: 100%;
}
</style>

<style scoped>
.grab-container {
  cursor: grab;
}

.grab-container:active{
  cursor: grabbing;
}
</style>